import React, { HTMLAttributes, useState, useRef } from 'react';
import './Accordion.css';
import AccordionItem, { AccordionEntry, TAccordionBackgroundColor } from './components/AccordionItem';

export interface IAccordionProps extends HTMLAttributes<HTMLDivElement> {
	items?: AccordionEntry[] | string[];
	firstOpen?: boolean;
	enableIcons?: boolean;
	disableBorder?: boolean;
	headerUnder?: boolean;
	backgroundColor?: TAccordionBackgroundColor;
	openAllOnLoad?: boolean;
	disableExpandAll?: boolean;
	additionalOnClick?: THandlerFunction;
}

const Accordion = ({
	items = [],
	id,
	className = '',
	backgroundColor,
	firstOpen = false,
	openAllOnLoad = false,
	enableIcons = false,
	disableBorder = false,
	headerUnder= false,
	disableExpandAll =false,
	additionalOnClick,
}: IAccordionProps) => {
	const [activeIndices, setActiveIndices] = useState<number[]>(openAllOnLoad ? [...items.keys()]: [firstOpen ? 0 : -1]);
	const componentId = useRef<string>(id ? id : `accordion-${window.crypto.getRandomValues(new Uint32Array(1))[0]}`);

	const handleSingle = (index: number) => {
		if (activeIndices.includes(index)) {
			setActiveIndices([...activeIndices.filter(item => item !== index)]);
		} else {
			setActiveIndices([...activeIndices, index])
		}
	};

	const handleAll = () => {
		if (activeIndices.length === items.length) {
			setActiveIndices([]);
		} else {
			setActiveIndices([...items.keys()])
		}
	};

	return (
		<div className='Accordion flex flex-col items-center justify-center' id={componentId.current}>
			<div className={`Accordion__contentContainer max-w-6xl w-full ${className}`}>
				<div className='Accordion__expandButtonContainer flex justify-end pr-3'>
					{!disableExpandAll &&
						<button className='Accordion__expandButton flex items-center text-blue-creditone cursor-pointer
										text-base font-normal leading-none border-0 bg-transparent my-4 tracking-normal underline' onClick={handleAll}>
							{activeIndices.length === items.length ? 'Collapse All' : 'Expand All'}
							<span className={`Accordion__expandArrow ml-auto pl-4 ${activeIndices.length === items.length ? 'active' : ''}`} />
						</button>
					}
				</div>
				<ul className='Accordion__content'>
					{items && items.length && items.map((item: IAccordionProps, index: number) => 
						<AccordionItem
							id={componentId.current} 
							key={index} 
							item={item} 
							backgroundColor={backgroundColor}
							enableIcons={enableIcons} 
							disableBorder={disableBorder} 
							headerUnder={headerUnder}
							index={index} 
							active={activeIndices.includes(index)} 
							onClick={handleSingle} 
							additionalOnClick={additionalOnClick}
						/>
					)}
				</ul>
			</div>
		</div>
	);
};

export default Accordion;
